import { Injectable, EventEmitter } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { jsPDF } from 'jspdf';
import * as html2canvas from 'html2canvas';
import * as moment from 'moment';
import _ from 'lodash';
import { CompanyName } from '../../constants';
// eslint-disable-next-line
let npsBeeHeard = require('../../../assets/js/nps-beeheard.js');

@Injectable()
export class DataService {

	data = {};
	pageData = {};
	dataCounts = {};
	unFilteredData = {};
	filteredData = {};
	filterCheck = 0;

	poData = {};
	// for cca Delegated POs tab
	delegatedPOs = [];

	poDetails: any = {};
	originalPODetails = {};
	poContractors = [];
	poPendingContractors = [];
	// the list of the contractor for the prevponum if it is available or
	// the list of the contractors for all pos
	poContractorSelections = [];
	filteredPOContractorSelections = [];
	replacementPODetails = null;
	limitDetails = {};

	poInvoices = [];
	poPendingInvoices = [];

	invoiceDetails = {};
	bcinvoiceDetails = {};
	calendarDetails = {};
	invoiceCalendars = [];

	userRequests = [];
	userRemoveDetails = {};
	availableContractors = [];
	poContractorDetails = null;
	newContractorDetails = null;

	contractorDetails = null;
	userRequestDetail = null;
	pendingTimesheets = [];
	timesheetDetails: any = {};
	timesheetRows = [];
	timesheetCorrectRows = [];
	timesheets = [];
	rejectedTimesheets = [];
	timesheetsRange = {};
	timesheetDocs = [];
	totalExpenses: number;
	correctExpenses: number;
	reasonCodes = [];

	validTimesheetMin: NgbDateStruct;
	validTimesheetMax: NgbDateStruct;

	contractorAddonsEdited = [];
	contractorAddons = [];

	accounts = [];
	searchAccounts = [];

	emptyAccountNodes = [{
		id: '',
		name: ''
	}];

	accountNodes = [{
		id: '',
		name: ''
	}];

	filteredAccountNodes = [{
		id: '',
		name: ''
	}];

	contractorNodes = [];
	newNode = {};

	userDetails = {};
	users = {};

	inputData = {};
	selectedTableRows = [];			// for table with checkbox selection type
	selectedTableRow = [];			// for table with single selection type

	quantityTypes = [];
	totalBillableHours = 0;
	totalOTHours = 0;

	dailyHoursByType = [];

	reasoncode = null;

	userSettings = {
		countryFilters: [],
		divisionFilters: [],
		costCenterFilters: [],
		notificationConfigs: []
	};

	// the following parms are needed for data-page which is non-carbon form
	divisioncode = [];		// the parm name need be the same as in config.csv
	countrycode = [];		// the parm name need be the same as in config.csv
	countryname = [];		// the parm name need be the same as in config.csv
	suppliername = [];		// the parm name need be the same as in config.csv
	companycode = ['', 'IBM', 'Kyndryl'];		// the parm name need be the same as in config.csv
	suppliers = [];
	rejectreasons = [];

	// the param names need to match the property name in the config.csv
	// this list of dropdown select options should use immutability (update to new object whenever updated)
	// so Angular change detection can notify components when it's been updated
	// this is intended to work with the data-form component
	lookupOptions = {
		countrycode: [],
		divisioncode: [],
		suppliername: [],
		rejectreasons: [],
		reconciliationstatus: ['', 'Failed', 'Forced Pass', 'Pass', 'Pending'],
		companycode: ['', 'IBM', 'Kyndryl'],
		costcenter: []
	};


	countries: any = {};

	// need undefined because purchase order doesn't use cost center
	emptyLabel = 'undefined';

	// a jason object to map poNumber to its userKeysObject
	userKeys = null;
	contractorPOs = [];
	// the selected PO (object) if contractor has multiple POs
	selectedPO = null;
	contractorcomment = '';
	landingPageMessage = 'You should be redirected to your landing page.';
	selectedInvoice;
	archivedPOs = [];

	auth = false;
	selectPersona = false;
	isLoggingInWithSSO = false;
	refreshToken = '';

	// moment format used by chaincode
	mdateFormat = 'YYYY-MM-DD HH:mm:ss Z';
	// date format
	dateFormat = 'YYYY-MM-DDTHH:mm:ssZ';

	zeroConfigs = {};

	bankHolidays: string[] = [];

	timeRangeChange: EventEmitter<any> = new EventEmitter();
	checkNotifications: EventEmitter<any> = new EventEmitter();
	checkPendingItems: EventEmitter<any> = new EventEmitter();
	fileDeleted: EventEmitter<any> = new EventEmitter();
	invoiceUpdated: EventEmitter<any> = new EventEmitter();
	poContractorsUpdated: EventEmitter<any> = new EventEmitter();
	poPendingContractorsUpdated: EventEmitter<any> = new EventEmitter();
	poContractorUpdated: EventEmitter<any> = new EventEmitter();
	contractorUpdated: EventEmitter<any> = new EventEmitter();
	loadAllCompleted: EventEmitter<any> = new EventEmitter();
	userSettingsUpdated: EventEmitter<any> = new EventEmitter();
	contractorAddonsUpdated: EventEmitter<any> = new EventEmitter();
	pageDataUpdated: EventEmitter<any> = new EventEmitter();
	timesheetLoadCompleted: EventEmitter<any> = new EventEmitter();

	constructor(
		private router: Router,
		private configService: ConfigService
	) { }


	// SETTERS

	updateUserSettings(userSettings) {
		this.userSettings = userSettings;
	}

	updateUserCodes(countryFilters, divisionFilters, costCenterFilters) {
		this.userSettings.countryFilters = countryFilters;
		this.userSettings.divisionFilters = divisionFilters;
		this.userSettings.costCenterFilters = costCenterFilters;
		this.broadcastUserSettings();
	}

	updateCountryCodes(data) {
		this.countrycode = data;
		// update legacy prop
		this.countrycode.sort();
		// update immutable object
		this.lookupOptions = { ...this.lookupOptions, countrycode: data};
		this.broadcastUserSettings();
	}

	updateRejectReasons(data) {
		this.rejectreasons = data;
		this.rejectreasons.sort();
		this.lookupOptions = {...this.lookupOptions, rejectreasons: data};
	}

	updateCountryNames(data) {
		this.countryname = data;
		this.countryname.sort();
	}

	updateDivisionCodes(data) {
		this.divisioncode = data;
		// update legacy prop
		this.divisioncode.sort();
		// update immutable object
		this.lookupOptions = { ...this.lookupOptions, divisioncode: data};
	}

	updateCostCenters(data) {
		// the source of truth list is stored in the settings service
		this.lookupOptions = { ...this.lookupOptions, costcenter: data };
	}

	updateSuppliers(data) {
		this.suppliers = data;
		this.suppliername = [];
		data.forEach(supplier => {
			const supNames = supplier.suppliernames;
			if (supNames && supNames.length > 0) {
				supNames.forEach(name => {
					this.suppliername.push(name);		// UI needs display supplier name
				});
			}
		});
		if (this.suppliername.length > 0) {
			this.suppliername.push('');
		}
		this.suppliername.sort();
		// update immutable object
		this.lookupOptions = { ...this.lookupOptions, suppliername: this.suppliername};
	}

	getSupplierCCIDbyName(name) {
		let id = '';
		const supplierFiltered = this.suppliers.filter(supplier => {
			const supNames = supplier.suppliernames.filter(supName => {
				return supName === name;
			});
			return supNames.length > 0;
		});
		if (supplierFiltered.length > 0) {
			id = supplierFiltered[0].id;
		}
		return id;
	}

	updateZeroConfigs(data) {
		console.log('UPDATE ZERO CONFIGS', data);
		this.zeroConfigs = data;
	}

	updatePageData(dataRef, tab, data) {
		if (this.pageData[dataRef] === undefined) {
			this.pageData[dataRef] = [];
		}
		this.pageData[dataRef][tab.page] = data;
		console.log('UPDATE PAGE DATA', dataRef, tab.page, data, this.pageData);
		if (data && data.length < 1) {
			console.log('PAGE LENGTH IS 0', data);
			tab.page = 0;
		}
	}

	updateDataCount(dataObj, count) {
		// if (count === undefined || count === '') {
		// 	count = 6;
		// }
		this.dataCounts[dataObj] = count;
		console.log('UPDATE DATA COUNTS', dataObj, count, this.dataCounts);
	}

	updateDataObj(dataObj, data) {
		this.data[dataObj] = data;
		this.unFilteredData[dataObj] = data;
		this.clearSelectedTableRows();
		console.log('UPDATED DATA: ', this.data);
		const self = this;
		switch (dataObj) {
			case 'contractor-pending':
				self.broadcastPendingItems(dataObj);
		}
	}

	replaceDataObj(dataObj, data) {
		this.data[dataObj] = data;
		console.log('REPLACE DATA: ', this.data);
	}

	updatePODataObj(dataObj, data) {
		this.poData[dataObj] = data;
		this.clearSelectedTableRows();
		console.log('UPDATED PO DATA: ', this.poData);
	}

	updatePODetails(data) {
		console.log('UPDATE PO DETAILS:', data);
		this.poDetails = data;
		if (data) {
			this.originalPODetails = _.cloneDeep(data);
			this.updateAvailableContractors(data.items);
		}
	}

	updateInvoiceCalendars(data) {
		console.log('UPDATE INVOICE CALENDARS:', data);
		this.invoiceCalendars = data;
	}

	updateInvoiceDetails(data) {
		console.log('UPDATE INVOICE DETAILS:', data);
		this.invoiceDetails = data;
	}

	updateBCInvoiceDetails(data) {
		console.log('UPDATE INVOICE DETAILS:', data);
		this.bcinvoiceDetails = data;
	}

	updateCalendarDetails(data) {
		console.log('UPDATE INVOICE CAL DETAILS:', data);
		this.calendarDetails = data;
	}

	updateReplacementPODetails(data) {
		this.replacementPODetails = data;
	}

	updateAvailableContractors(data) {
		this.availableContractors = data;
	}

	updateContractorDetails(data) {
		console.log('UPDATE CONTRACTOR DETAILS:', data);
		// this.contractorNodes = contractorNodes;
		this.contractorDetails = data;
		// this.accounts = data.accounts;
		this.broadcastContractor();
		this.pageDataUpdated.emit({
			data: data
		});
	}

	updateNewContractorDetails(data) {
		console.log('UPDATE NEW CONTRACTOR DETAILS:', data);
		this.newContractorDetails = data;
		this.poContractorDetails = null;
		this.pageDataUpdated.emit({
			data: data
		});
	}

	updatePOContractors(data) {
		console.log('UPDATE PO CONTRACTORS:', data);
		this.poContractors = data;
		this.clearSelectedTableRows();
	}

	updatePOPendingContractors(data) {
		console.log('UPDATE PO PENDING CONTRACTORS:', data);
		this.poPendingContractors = data;
		this.clearSelectedTableRows();
	}

	updatePOContractorSelections(data) {
		console.log('UPDATE PO CONTRACTORS:', data);
		this.poContractorSelections = data;
		this.filteredPOContractorSelections = data;
	}

	updatePOContractorDetails(data) {
		console.log('UPDATE PO CONTRACTOR DETAIL:', data);
		// this.contractorNodes = contractorNodes;
		this.poContractorDetails = data;
		this.newContractorDetails = null;
		this.pageDataUpdated.emit({
			data: data
		});
	}

	updatePendingTimesheets(data) {
		console.log('UPDATE PENDING TIMESHEETS:', data);
		this.pendingTimesheets = data;
		this.clearSelectedTableRows();
	}

	updateTimesheet(data) {
		console.log('UPDATE TIMESHEET:', data, data.accounts);
		this.timesheetDetails = data;
		// this.accounts = data.accounts;
		this.totalExpenses = this.getTimesheetExpenses();
		this.correctExpenses = this.getTimesheetCorrectExpenses();
		this.contractorcomment = data.contractorcomment;
		if (data[this.configService.timeentryProp]
			&& data[this.configService.timeentryProp][0]
			&& data[this.configService.timeentryProp][0][this.configService.contractorAddonsProp]
			&& data[this.configService.timeentryProp][0][this.configService.contractorAddonsProp][0]) {
				this.reasoncode = {
					prop: data[this.configService.timeentryProp][0][this.configService.contractorAddonsProp][0]['value']
				};
			}
	}

	updateReasoncode(data) {
		console.log('UPDATE ILC REASON CODE:', data);
		this.reasoncode = data;
	}

	updateTimesheetRows(data, isCorrection) {
		console.log('UPDATE TIMESHEET ROWS:', data);
		if (isCorrection) {
			this.timesheetCorrectRows = data;
		} else {
			this.timesheetRows = data;
		}
	}

	// update timesheets in contractor page
	updateTimesheets(data) {
		console.log('UPDATE TIMESHEETS:', data);
		this.timesheets = data;
		this.updateRejectedTimesheets(data);
	}

	updateRejectedTimesheets(data) {
		this.rejectedTimesheets = [];
		if (data && data.length > 0) {
			this.rejectedTimesheets = data.filter((ts) => {
				return ts.statusdescription.indexOf(this.configService.timesheetRejectedStatus) >= 0;
			});
		}
	}

	updateTimesheetsRange(data) {
		console.log('UPDATE TIMESHEETS RANGE:', data);
		this.timesheetsRange = data;
		this.timeRangeChange.emit({
			data: data
		});
	}

	updateTimesheetDocs(data) {
		console.log('UPDATE TIMESHEET DOCS:', data);
		this.timesheetDocs = data;
	}

	updateSearchAccounts(data) {
		console.log('UPDATE SEARCH ACCTS:', data);
		this.searchAccounts = data;
	}

	updateAccounts(data) {
		// console.log('UPDATE ACCOUNTS:', data);
		this.accounts = data;
	}

	updateAccountNodes(data) {
		console.log('UPDATE ACCOUNT NODES:', data);
		if (data && data.length > 0) {
			this.accountNodes = data;
		} else {
			this.accountNodes = this.emptyAccountNodes;
		}
	}

	updateFilteredAccountNodes(data) {
		console.log('UPDATE ACCOUNT NODES:', data);
		if (data && data.length > 0) {
			this.filteredAccountNodes = data;
		} else {
			this.filteredAccountNodes = this.emptyAccountNodes;
		}
	}

	updateContractorNodes(data) {
		console.log('UPDATE CONTRACTOR NODES:', data);
		this.contractorNodes = data;
	}

	updateQuantityTypes(data) {
		console.log('UPDATE QUANTITY TYPES:', data);
		this.quantityTypes = data;
	}

	updateUser(data) {
		console.log('UPDATE USER:', data);
		this.userDetails = data;
	}

	updateUsers(role, data) {
		console.log('UPDATE USERS:', role, data);
		this.users[role] = data;
	}

	updateUserRemoveDetails(data) {
		console.log('UPDATE USER REMOVE DETAILS:', data);
		this.userRemoveDetails = data;
	}

	updateUserRequests(data) {
		console.log('UPDATE USER REQUESTS:', data);
		this.userRequests = data;
	}

	updateUserRequestDetails(data) {
		console.log('UPDATE USER REQUESTS DETAILS:', data);
		this.userRequestDetail = data;
	}

	updateMinMaxDates() {
		const minMax = this.getMinMaxDates();
		const today = new Date();

		if (minMax.max > today) {
			// time difference in milleseconds
			const timeDiffFromToday = Math.abs(minMax.max.getTime() - today.getTime());
			// days difference
			const diffDaysFromToday = Math.ceil(timeDiffFromToday / (1000 * 3600 * 24));
			if (diffDaysFromToday > 28) {
				minMax.max = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 28);
			}
		}
		this.validTimesheetMin = { day: minMax.min.getUTCDate(), month: minMax.min.getUTCMonth() + 1, year: minMax.min.getUTCFullYear() };
		this.validTimesheetMax = { day: minMax.max.getUTCDate(), month: minMax.max.getUTCMonth() + 1, year: minMax.max.getUTCFullYear() };
		console.log('MIN MAX', this.validTimesheetMin, this.validTimesheetMax);
	}

	updateContractorAddons(data) {
		this.contractorAddons = data;
		if (Array.isArray(data)) {
			this.contractorAddonsEdited = _.cloneDeep(this.contractorAddons);
		}
		this.contractorAddonsUpdated.emit({
			data: data
		});
	}

	// BROADCASTERS

	broadcastNotifications(origin) {
		this.checkNotifications.emit({
			origin: origin
		});
	}

	broadcastPendingItems(origin) {
		console.log('BROADCAST PENDING ITEMS');
		this.checkPendingItems.emit({
			origin: origin
		});
	}

	boadcastFileDelete() {
		this.fileDeleted.emit();
	}

	broadcastInvoiceUpdate() {
		console.log('BROADCAST INVOICE UPDATE');
		this.invoiceUpdated.emit();
	}

	broadcastPOContractors() {
		console.log('BROADCAST PO CONTRACTORS UPDATE');
		this.poContractorsUpdated.emit();
	}

	broadcastPOPendingContractors() {
		console.log('BROADCAST PO PENDING CONTRACTORS UPDATE');
		this.poPendingContractorsUpdated.emit();
	}

	broadcastPOContractor() {
		console.log('BROADCAST PO CONTRACTOR UPDATE');
		this.poContractorUpdated.emit();
	}

	broadcastContractor() {
		console.log('BROADCAST CONTRACTOR UPDATE');
		this.contractorUpdated.emit();
	}

	broadcastLoadAll(data) {
		this.loadAllCompleted.emit({
			data: data
		});
	}

	broadcastUserSettings() {
		this.userSettingsUpdated.emit();
	}

	broadcastTimesheetLoadCompleted() {
		this.timesheetLoadCompleted.emit();
	}

	// LISTENERS

	timeRangeChangeListener() {
		return this.timeRangeChange;
	}

	notificationsListener() {
		return this.checkNotifications;
	}

	pendingItemsListener() {
		return this.checkPendingItems;
	}

	fileDeletionListener() {
		return this.fileDeleted;
	}

	invoiceUpdateListener() {
		return this.invoiceUpdated;
	}

	poContractorsUpdateListener() {
		return this.poContractorsUpdated;
	}

	poPendingContractorsUpdateListener() {
		return this.poPendingContractorsUpdated;
	}

	poContractorUpdateListener() {
		return this.poContractorUpdated;
	}

	contractorUpdateListener() {
		return this.contractorUpdated;
	}

	loadAllListener() {
		return this.loadAllCompleted;
	}

	userSettingsListener() {
		return this.userSettingsUpdated;
	}

	contractorAddonsUpdateListener() {
		return this.contractorAddonsUpdated;
	}

	pageDataUpdateListener() {
		return this.pageDataUpdated;
	}

	timesheetLoadListener() {
		return this.timesheetLoadCompleted;
	}

	// GETTERS
	getDefaultCalendarId() {
		let defaultCalendarId = '';
		const self = this;
		this.invoiceCalendars.forEach(function (d, i) {
			if (d[self.configService.calendarIsDefaultProp] === true || d[self.configService.calendarIsDefaultProp] === 'true') {
				defaultCalendarId = d[self.configService.invoiceCalIdProp];
			}
		});
		return defaultCalendarId;
	}

	getAvailableContractor(data, prop) {
		let matchedContractor = {};
		this.availableContractors.forEach(function (d, i) {
			if (d[prop] === data) {
				matchedContractor = d;
			}
		});
		return matchedContractor;
	}

	getUsersByRole(role) {
		return this.users[role];
	}

	getTimesheetContractorStart() {
		try {
			console.log('GET CONT START', this.contractorDetails[this.configService.contractorStartProp]);
			return this.contractorDetails[this.configService.contractorStartProp];
		} catch (e) {
			return '';
		}
	}

	getTimesheetContractorEnd() {
		try {
			console.log('GET CONT END', this.contractorDetails[this.configService.contractorEndProp]);
			const contractorEndDate = this.applyGracePeriod(new Date(this.contractorDetails[this.configService.contractorEndProp]));
			return contractorEndDate;
		} catch (e) {
			return '';
		}
	}

	applyGracePeriod(date) {
		// 28 days grace period has been removed
		const wDay = date.getUTCDay();

		// extend to end of a timesheet week (which is saturday to friday)
		// if saturday (6), extend date by 6 to move forward to show until friday
		const daysToExtend = wDay === 6 ? 6 : (5 - wDay);
		const newDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + daysToExtend));

		return newDate;
	}

	getTimeEntries(isCorrection) {
		try {
			if (isCorrection) {
				return this.timesheetDetails['timeentryforperiod'][0].correctionentries;
			} else {
				return this.timesheetDetails['timeentryforperiod'][0].timeentries;
			}
		} catch (e) {
			return [];
		}
	}

	getTimeLock() {
		// console.log('GET TIME LOCK', this.timesheetDetails);
		return this.timesheetDetails['islocked'];
	}

	getTimesheetStart() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].startdate;
		} catch (e) {
			return '';
		}
	}

	getTimesheetEnd() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].enddate;
		} catch (e) {
			return '';
		}
	}

	getTimesheetStatus() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].status;
		} catch (e) {
			return '';
		}
	}

	getTimesheetStatusDescription() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0][this.configService.timesheetStatusProp];
		} catch (e) {
			return '';
		}
	}

	getTimesheetInvoiceStatus() {
		try {
			return this.timesheetDetails[this.configService.timesheetInvoiceStatusProp];
		} catch (e) {
			return '';
		}
	}

	isTimesheetHoursLock() {
		try {
			return this.timesheetDetails[this.configService.timesheetContractorLockProp];
		} catch (e) {
			return false;
		}
	}

	isTimesheetCRR() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0][this.configService.timesheetIsCRRReconciledProp];
		} catch (e) {
			return false;
		}
	}

	isTimesheetNew() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].statusdescription === '';
		} catch (e) {
			return '';
		}
	}

	getTimesheetApprovalStatus() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].approval.approvalstatus;
		} catch (e) {
			return '';
		}
	}

	getTimesheetBuyerStatus() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].approval.buyerapprovalstatus;
		} catch (e) {
			return '';
		}
	}

	getTimesheetRejectStatus() {
		let status = this.configService.timesheetRejectedStatus;
		if (this.getTimesheetBuyerStatus() === status
			&& this.getTimesheetSupplierStatus() !== status) {
			status = 'rejected by the manager';
		}
		if (this.getTimesheetBuyerStatus() !== status
			&& this.getTimesheetSupplierStatus() === status) {
			status = 'rejected by the supplier account manager';
		}
		return status;
	}

	getTimesheetSupplierStatus() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0][this.configService.timesheetApprovalObjProp][this.configService.timesheetSAMApprovalStatusProp];
		} catch (e) {
			return '';
		}
	}

	getTimesheetExpenses() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].expenses.total;
		} catch (e) {
			return '';
		}
	}

	getTimesheetCorrectExpenses() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].correctionexpenses.total;
		} catch (e) {
			return '';
		}
	}

	getTimesheetCorrectionStatus() {
		try {
			return this.timesheetDetails['timeentryforperiod'][0].correctionentries;
		} catch (e) {
			return '';
		}
	}

	getTimesheetDocs(type) {
		const timesheetDocs = [];
		if (Array.isArray(this.timesheetDocs)) {
			this.timesheetDocs.forEach(function (d, i) {
				if (d.type === type) {
					timesheetDocs.push(d);
				}
			});
		}
		return timesheetDocs;
	}

	getInvoiceRecStatus() {
		return this.invoiceDetails[this.configService.invoiceRecStatusProp];
	}

	getContractorId() {
		return this.contractorDetails[this.configService.contractorIdProp];
	}



	// CLEANERS

	clearData() {
		this.removeNPSButton();
		this.data = {};
		this.unFilteredData = {};
		this.filteredData = {};
		this.filterCheck = 0;

		this.poDetails = {};
		this.poContractors = [];
		this.selectedPO = null;
		this.userRequests = [];
		this.availableContractors = [];
		this.poContractorDetails = null;
		this.newContractorDetails = null;

		this.contractorDetails = null;
		this.userRequestDetail = {};
		this.pendingTimesheets = [];
		this.timesheetDetails = {};
		this.timesheetRows = [];
		this.timesheets = [];
		this.rejectedTimesheets = [];
		this.timesheetsRange = {};
		this.timesheetDocs = [];
		this.totalExpenses = 0;
		this.correctExpenses = 0;

		this.contractorNodes = [];
		this.newNode = {};

		this.users = {};

		this.userKeys = null;
		this.contractorPOs = [];

		this.clearAccounts();
		this.clearInputData();
		this.clearSelectedTableRows();
		this.selectPersona = false;
		this.auth = false;
		this.pageData = {};
		this.userSettings = {
			countryFilters: [],
			divisionFilters: [],
			costCenterFilters: [],
			notificationConfigs: []
		};

		this.divisioncode = [];
		this.countrycode = [];
		this.suppliername = [];
		this.suppliers = [];

		this.contractorAddonsEdited = [];
		this.contractorAddons = [];

		console.log('CLEARED DATA');
	}

	clearAccounts() {
		this.accounts = [];
		this.accountNodes = this.emptyAccountNodes;
		this.filteredAccountNodes = this.emptyAccountNodes;
	}

	clearSearchAccounts() {
		this.searchAccounts = [];
	}

	clearInputData() {
		this.inputData = {};
	}

	clearSelectedTableRows() {
		this.selectedTableRows = [];
	}

	clearSelectedTableRow() {
		this.selectedTableRow = [];
	}

	clearContractorNodes() {
		this.contractorNodes = [];
	}

	clearPOContractor() {
		this.poContractorDetails = null;
		this.newContractorDetails = null;
	}

	clearContractor() {
		this.contractorDetails = null;
	}

	clearUserRequestDetails() {
		this.userRequestDetail = null;
	}

	clearReplacementPODetails() {
		this.replacementPODetails = null;
	}

	clearInvoiceDetails() {
		this.invoiceDetails = {};
	}

	clearTimesheetData() {
		this.timesheetDetails = {};
		this.clearTimesheetRows();
	}

	clearTimesheetRows() {
		this.timesheetRows = [];
		this.timesheetCorrectRows = [];
		this.timesheetDocs = [];
		this.totalExpenses = 0;
		this.correctExpenses = 0;
		this.totalBillableHours = 0;
		console.log('CLEARED TIMESHEET ROWS DATA');
	}



	// CONVERTERS

	emptyFields(dataConfig) {
		const emptyFields = {};
		dataConfig.fields.forEach(function (d, i) {
			emptyFields[d.prop] = '';
		});
		return emptyFields;
	}

	makeReasonAction(data) {
		return {
			prop: data.code,
			name: data.description,
			abbr: data.descaabr
		};
	}

	/*
	Method to apply acl edits to acl object within supplied data based on supplied data configs
	*/
	applyACL(data, personas, config, overwrite) {
		const newData = _.cloneDeep(data);
		// if acl object doesn't exist create one
		if (newData['acl'] === undefined) {
			newData['acl'] = {};
			personas.forEach((d, i) => {
				// if user has edit rights to the acl field them create an empty participants array for that acl persona
				if (this.configService.canDo(config, 'acl' + d.prop, 'edit')) {
					newData['acl'][d.prop] = {
						participants: []
					};
				}
			});
		}
		// loop through personas
		// if acl field has data and user has edit rights push value to participants array
		personas.forEach((d, i) => {
			if (newData['acl' + d.prop] !== undefined && newData['acl' + d.prop] !== '' && this.configService.canDo(config, 'acl' + d.prop, 'edit')) {
				if (overwrite) {
					newData['acl'][d.prop]['participants'] = [];
				}
				newData['acl'][d.prop]['participants'].push(newData['acl' + d.prop]);
			}
		});

		if (_.isEmpty(newData['acl'])) {
			delete newData['acl'];
		}
		console.log('APPLY ACL', newData);
		// return data;
		return newData;
	}

	/*
	Method to pull acl participants out of acl object and apply them to the viewable acl fields
	*/
	showACL(data, personas, config, configService) {
		const newData = _.cloneDeep(data);
		const self = this;
		// if the acl object doesn't exist
		/* dont show the first one
		if (newData['acl'] === undefined) {
			// loop through personas
			personas.forEach(function (d, i) {
				try {
					// set acl field value to first option of available users for matching persona
					if (configService.canDo(config, 'acl' + d.prop, 'view')) {
						newData['acl' + d.prop] = self.getUsers(d.prop)[0].email;
						console.log('SHOWING ACL', d.prop, newData['acl' + d.prop]);
					}
				} catch (e) {
					// console.log('ERROR SHOWING ACL', d.prop, e);
				}
			});
			// if the acl object does exist
		} else {
		*/
		if (newData['acl']) {
			// loop through personas
			personas.forEach(function (d, i) {
				try {
					// transfer participant to acl field for viewing
					newData['acl' + d.prop] = newData['acl'][d.prop]['participants'][0];
				} catch (e) { }
			});
		}
		return newData;
	}



	// DATA FILTERING

	filterDataObj(group, filters) {
		this.router.navigateByUrl(group.path);
		const self = this;
		const delay = setTimeout(function () {
			group.service.selectActiveTab(group.tabs, group.tab);
			self.filterCheck = 0;
			self.checkForFilters(group, filters);
		}, 1000);
	}

	checkForFilters(group, filters) {
		this.filterCheck++;
		const data = _.cloneDeep(this.unFilteredData[group.dataObj]);
		console.log('CHECK FOR FILTERS', this.filterCheck, data, group, filters);
		const self = this;
		if (data !== undefined && data !== null) {
			this.executeFilters(group, filters, data);
		} else {
			if (this.filterCheck < 6) {
				const delay = setTimeout(function () {
					self.checkForFilters(group, filters);
				}, 2000);
			}
		}
	}

	executeFilters(group, filters, data) {
		const dataObj = group.dataObj;
		console.log('EXECUTE FILTERS', group, filters, data);
		const filteredData = [];
		const self = this;
		filters.forEach(function (filter, filterI) {
			const foundItems = [];
			data.forEach(function (d, i) {
				if (d[filter.prop].toLowerCase().indexOf(filter.value.toLowerCase()) > -1) {
					if (!self.alreadyFound(d, foundItems)) {
						foundItems.push(d);
					}
				}
			});
			filteredData.push(foundItems);
		});
		// console.log('FILTERED DATA', filteredData);
		const toAnd = _.cloneDeep(filteredData);

		let andData = toAnd[0];
		toAnd.forEach(function (d, i) {
			if (toAnd.length > i + 1) {
				const andPass = _.intersection(andData, toAnd[i + 1]);
				andData = andPass;
			}
		});
		// console.log('AND DATA', andData);
		this.replaceDataObj(dataObj, andData);
		this.filteredData[dataObj] = true;
	}


	// DATA CHECKING

	alreadyFound(data, foundData) {
		let alreadyFound = false;
		foundData.forEach(function (d, i) {
			if (d === data) {
				alreadyFound = true;
			}
		});
		return alreadyFound;
	}

	isJson(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	// FORMATTERS

	getDateFromTimestamp(timestamp) {
		if (timestamp > 0) {
			const date = new Date(timestamp * 1000);
			const dateString = this.formatLocalDate(date) + ' ' + this.formatLocalTime(date);
			// console.log('GET DATE FROM TIMESTAMP', timestamp, dateString, date.getUTCFullYear());
			return dateString;
		} else {
			return '-';
		}
	}

	// convert 'yyyy-mm-dd'
	getDatepickerModel(dateString) {
		const arr = dateString.split('-');
		let dJson: any = {};
		try {
			if (arr && arr.length === 3) {
				dJson = {
					year: Number(arr[0]),
					month: Number(arr[1]),
					day: Number(arr[2])
				};
			}
		} catch (error) {
			console.error('Error occurred during retrieving date json from date string');
		}
		return dJson;
	}

	// convert {year: ****, month: **, day: **}
	formatPickerDate(pickerDate) {
		const year = pickerDate.year;
		const month = this.makeDoubleDiget(pickerDate.month);
		const day = this.makeDoubleDiget(pickerDate.day);
		return year + '-' + month + '-' + day;
	}

	formatDate(date) {
		let month = '' + (date.getUTCMonth() + 1);
		let day = '' + date.getUTCDate();
		const year = date.getUTCFullYear();
		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}
		return [year, month, day].join('-');
	}

	formatLocalDate(date) {
		let month = '' + (date.getMonth() + 1);
		let day = '' + date.getDate();
		const year = date.getFullYear();
		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}
		return [year, month, day].join('-');
	}

	formatTime(date) {
		let hours = date.getUTCHours();
		let minutes = date.getUTCMinutes();
		const ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		return hours + ':' + minutes + ' ' + ampm;
	}

	formatDateTime(dateString) {
		let newDateStr = '';
		if (dateString) {
			const date = this.convertMomentToDate(dateString);
			newDateStr = this.formatDate(date) + ' ' + this.formatTime(date);
		}
		return newDateStr;
	}

	formatDateFromString(dateString) {
		let newDateStr = '';
		if (dateString) {
			const date = this.convertMomentToDate(dateString);
			newDateStr = this.formatDate(date);
		}
		return newDateStr;
	}

	convertMomentToDate(dateString) {
		let newDate = null;
		if (dateString) {
			newDate = new Date(moment(dateString, this.mdateFormat).format(this.dateFormat));
		}
		return newDate;
	}

	formatLocalTime(date) {
		let hours = date.getHours();
		let minutes = date.getMinutes();
		const ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		const offset = (date.getTimezoneOffset() / -60) + ':00';
		return hours + ':' + minutes + ' ' + ampm + ' GMT' + offset;
	}

	getShortDate(dateString) {
		const date = new Date(dateString);
		let month = '' + (date.getUTCMonth() + 1);
		let day = '' + date.getUTCDate();
		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}
		const shortDate = [month, day].join('/');
		// console.log('GET SHORT DATE', dateString, shortDate);
		return shortDate;
	}

	getWeekday(dateString) {
		const date = new Date(dateString);
		const day = date.getUTCDay();
		// console.log('GET WEEKDAY', dateString, date, day);
		return this.configService.utcWeekDays[day];
	}

	getNextDay(date) {
		const nextDay = new Date(date);
		nextDay.setDate(nextDay.getDate() + 1);
		return nextDay;
	}

	makeDoubleDiget(number) {
		let doubleDiget;
		if (parseInt(number, 10) < 10) {
			doubleDiget = '0' + number;
		} else {
			doubleDiget = number;
		}
		return doubleDiget;
	}

	setUserKeys(userKeysArr) {
		this.contractorPOs = [];
		this.userKeys = null;
		if (userKeysArr && userKeysArr.length > 0) {
			this.userKeys = {};
			const self = this;
			userKeysArr.forEach(item => {
				const poNum = item[self.configService.poNumberProp];
				this.userKeys[poNum] = item;
			});
			if (userKeysArr.length > 1) {
				this._setContractorPOs();
			}
		}
	}

	_setContractorPOs() {
		if (this.userKeys) {
			// there are duplicate POnumber in userkeys
			// when the same email is shared among the contractors
			const poNums = Object.keys(this.userKeys);
			poNums.forEach(poNum => {
				const poObj = this.userKeys[poNum];
				this.contractorPOs.push({
					name: poNum,
					prop: poNum,
					po: poObj.po,
					companycode: poObj.companycode,
					actualstartdate: poObj[this.configService.contractorStartProp],
					actualenddate: poObj[this.configService.contractorEndProp],
					tooltip: poObj[this.configService.contractorStartProp] + ' - ' + poObj[this.configService.contractorEndProp]
				});
			});
			// sort POs so most recent dates come first
			this.contractorPOs.sort((a, b) => {
				if (a.actualenddate < b.actualenddate) {
					return 1;
				}
				if (a.actualenddate > b.actualenddate) {
					return -1;
				}
				if (a.actualenddate === b.actualenddate) {
					if (a['po'] && b['po'] && (a['po'][this.configService.poIssueDateProp] < b['po'][this.configService.poIssueDateProp])) {
						return 1;
					}
					if (a['po'] && b['po'] && (a['po'][this.configService.poIssueDateProp] > b['po'][this.configService.poIssueDateProp])) {
						return -1;
					}
				}
				return 0;
			});
			// split and filter the list to make sure all Kyndryl POs come before IBM POs
			this.contractorPOs = [
				...this.contractorPOs.filter(po => po.companycode.toUpperCase() === CompanyName.Kyndryl.toUpperCase()),
				...this.contractorPOs.filter(po => po.companycode.toUpperCase() !== CompanyName.Kyndryl.toUpperCase())
			];
			this.contractorPOs.map(item => delete item['actualenddate']);
		}
	}

	/**
	 * Sets dataService's selectedPO property based on a list of POs
	 */
	setContractorSelectedPO(poSelections?: Array<any>): void {
		// need call setUserKeys() first
		if (!poSelections) {
			poSelections = this.contractorPOs;
		}
		// if selectedPO is already set, then just find the matching item from the given list
		if (this.selectedPO) {
			const currentSelectedPO = poSelections.filter(po => po.name === this.selectedPO.name && po.prop === this.selectedPO.prop);
			if (currentSelectedPO.length > 0) {
				this.selectedPO = currentSelectedPO[0];
				return;
			}
		}
		// set the first PO which is before or on the current date, and which is not cancelled
		if (poSelections && poSelections.length > 0) {
			for (let i = 0; i < poSelections.length; i++) {
				if (poSelections[i]['po'] && poSelections[i]['po']['cancellation']) {
					continue;
				}
				const startdate = new Date(poSelections[i].actualstartdate);
				if (startdate <= new Date()) {
					this.selectedPO = poSelections[i];
					break;
				}
			}
		}
	}

	updateComment(event) {
		this.contractorcomment = event;
	}

	getCharCount() {
		if (this.contractorcomment.length) {
			return 250 - this.contractorcomment.length;
		}
		return 250;
	}

	getMinMaxDates() {
		if (this.contractorDetails) {
			return {
				min: new Date(this.contractorDetails[this.configService.contractorStartProp]),
				max: new Date(this.contractorDetails[this.configService.contractorEndProp])
			};
		} else {
			console.log('NO CONTRACTOR RECORD FOR MIN MAX DATES');
			return {
				min: new Date(),
				max: new Date()
			};
		}

	}

	// HELPERS

	isEqual(value, other) {

		const self = this;

		// Get the value type
		const type = Object.prototype.toString.call(value);

		// If the two objects are not the same type, return false
		if (type !== Object.prototype.toString.call(other)) { return false; }

		// If items are not an object or array, return false
		if (['[object Array]', '[object Object]'].indexOf(type) < 0) { return false; }

		// Compare the length of the length of the two items
		const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
		const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
		if (valueLen !== otherLen) { return false; }

		// Compare two items
		const compare = function (item1, item2) {

			// Get the object type
			const itemType = Object.prototype.toString.call(item1);

			// If an object or array, compare recursively
			if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
				if (!self.isEqual(item1, item2)) { return false; }
			} else {

				// If the two items are not the same type, return false
				if (itemType !== Object.prototype.toString.call(item2)) { return false; }

				// Else if it's a function, convert to a string and compare
				// Otherwise, just compare
				if (itemType === '[object Function]') {
					if (item1.toString() !== item2.toString()) { return false; }
				} else {
					if (item1 !== item2) { return false; }
				}

			}
		};

		// Compare properties
		if (type === '[object Array]') {
			for (let i = 0; i < valueLen; i++) {
				if (compare(value[i], other[i]) === false) { return false; }
			}
		} else {
			for (const key in value) {
				if (value.hasOwnProperty(key)) {
					if (compare(value[key], other[key]) === false) { return false; }
				}
			}
		}

		// If nothing failed, return true
		return true;

	}

	getEmailsByRole(role) {
		const emails = [];
		if (this.users[role] && this.users[role].length > 0) {
			this.users[role].forEach(user => {
				emails.push(user.email);
			});
		}
		return emails;
	}

	convertVerifyString(searchValue) {
		if (searchValue) {
			const values = searchValue.split(' ');
			const mappedValues = values.map(item => item.toLowerCase().startsWith('v') ? 'approv' : item);
			searchValue = mappedValues.join(' ');
		}
		return searchValue;
	}

	convertApproveString(status) {
		if (status) {
			status = status.replace(/approval/gi, 'verification');
			status = status.replace(/approved/gi, 'verified');
		}
		return status;
	}

	getTodaysDate() {

		const today = new Date();
		const dd = today.getDate();
		const mm = today.getMonth() + 1; // January is 0!
		const yyyy = today.getFullYear();
		let day = '';
		let month = '';
		if (dd < 10) {
			day = '0' + String(dd);
		} else {
			day = String(dd);
		}

		if (mm < 10) {
			month = '0' + String(mm);
		} else {
			month = String(mm);
		}

		return + yyyy + '-' + month + '-' + day;
	}

	getDateString(dateModel) {
		let ds = '';
		if (dateModel) {
			let month = '' + dateModel.month;
			let day = '' + dateModel.day;
			if (month.length < 2) {
				month = '0' + month;
			}
			if (day.length < 2) {
				day = '0' + day;
			}
			ds = [dateModel.year, month, day].join('-');
		}
		return ds;
	}

	loadNPSInlineJS() {
		const btn = document.getElementById('beeheard-buttons-con');
		if (!btn) {
			npsBeeHeard.run();
		}
		this.repositionNPSButton();
	}

	/**
	 * Keep checking for NPS button until found and then reposition it
	 */
	repositionNPSButton() {
		const feedbackButton = document.getElementById('beeheard-buttons-con') as HTMLElement;
		if (feedbackButton) {
			// this pushes the button away from the edge approximately the size of the scroll bar, since the scrollbar is always visible,
			// so the button doesn't block the scroll bar itself
			feedbackButton.style.right = '14px';
		} else {
			setTimeout(() => {
				this.repositionNPSButton();
			}, 250);
		}
	}

	removeNPSButton() {
		const btn = document.getElementById('beeheard-buttons-con');
		if (btn) {
			btn.remove();
		}
	}

	allowBankHolidaysEdit(isCorrectRow, row, col) {
		if ( this.timesheetDetails.countrycode === this.configService.countryCodes.US) {
			return true;
		}
		let allowEdit = true;
		let tsRow = this.timesheetRows[row];
		if (isCorrectRow) {
			tsRow = this.timesheetCorrectRows[row];
		}
		const wkDay = this.getWeekday(tsRow[col].date);
		// disable weekends and bank holidays for ST
		if ((tsRow[0].key === 'standard' || tsRow[0].type === 'straighttime')
			&& (wkDay === 'Sat' || wkDay === 'Sun' || this.bankHolidays.indexOf(tsRow[col].date) > -1)) {
			allowEdit = false;
		}
		return allowEdit;
	}

	isBankHoliday(isCorrectRow, row, col) {
		let isHoliday = false;
		let tsRow = this.timesheetRows[row];
		if (isCorrectRow) {
			tsRow = this.timesheetCorrectRows[row];
		}
		if ( this.bankHolidays?.indexOf(tsRow[col].date) > -1) {
			isHoliday = true;
		}
		return isHoliday;
	}

	downloadToPDF(content, fileName) {
		const HTML_W = content.clientWidth;
		const HTML_H = content.clientHeight;
		const top_left_margin = 15;
		const PDF_W = HTML_W + (top_left_margin * 2);
		const PDF_H = (PDF_W * 1.5) + (top_left_margin * 2);
		const canvas_image_w = HTML_W;
		const canvas_image_h = HTML_H;
		const totalPDFPages = Math.ceil(HTML_H / PDF_H) - 1;

		(html2canvas as any)(content, {allowTaint: true}).then((canvas) => {
			const imgData = canvas.toDataURL('image/jpeg', 1.0);
			const pdf = new jsPDF('p', 'pt',  [PDF_W, PDF_H]);
			pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_w, canvas_image_h);

			for (let i = 1; i <= totalPDFPages; i++) {
				pdf.addPage([PDF_W, PDF_H], 'p');
				pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_H * i) + (top_left_margin * 4), canvas_image_w, canvas_image_h);
			}

			pdf.save(fileName);
		});
	}

}
